// 常量
export const FITTING_COUNT = 100
export const HALF_PI = Math.PI / 2
export const ZERO_TOLERANCE = 0.000003
export const TWO_PI = Math.PI * 2
export const ERADIUS = 6378137; //赤道半径
export const PRADIUS = 6356725; //极半径